export const getCopyMachineCoords = (
  machine: { x: number; y: number },
  map: {
    width: number;
    height: number;
    ratio: number;
  }
): { x: number; y: number } => {
  const maxX = (map.width ?? 0) / map.ratio;
  const maxY = (map.height ?? 0) / map.ratio;

  return {
    x: maxX < machine.x + 50 ? machine.x - 50 : machine.x + 50,
    y: maxY < machine.y + 50 ? machine.y - 50 : machine.y + 50,
  };
};

export const getRotatedRectBoundingBox = (
  x: number,
  y: number,
  width: number,
  height: number,
  rotation: number
): { x: number; y: number; width: number; height: number } => {
  if (rotation === 0) {
    return { x, y, width, height };
  }

  const rad = (rotation * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);

  const cx = x + width / 2;
  const cy = y + height / 2;

  const points = [
    { x: x, y: y },
    { x: x + width, y: y },
    { x: x, y: y + height },
    { x: x + width, y: y + height },
  ];

  const rotatedPoints = points.map((p) => {
    const dx = p.x - cx;
    const dy = p.y - cy;
    return {
      x: cx + dx * cos - dy * sin,
      y: cy + dx * sin + dy * cos,
    };
  });

  const xs = rotatedPoints.map((p) => p.x);
  const ys = rotatedPoints.map((p) => p.y);

  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);

  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY,
  };
};

export const isNearCardinal = (rotationDeg: number, tolerance = 10): boolean => {
  const normalize = (a: number) => ((a % 360) + 360) % 360;
  const diff = (a: number, b: number) => {
    const d = Math.abs(normalize(a) - normalize(b));
    return Math.min(d, 360 - d); // 円周上の最短距離
  };

  const r = normalize(rotationDeg);
  const cardinals = [0, 90, 180, 270, 360];
  return cardinals.some((c) => diff(r, c) <= tolerance);
};
